var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5002 1.66692C15.5002 1.88025 15.4185 2.09358 15.256 2.25608L8.58937 8.92275C8.26354 9.24858 7.73688 9.24858 7.41104 8.92275L0.744375 2.25608C0.418542 1.93025 0.418542 1.40358 0.744375 1.07775C1.07021 0.751916 1.59687 0.751916 1.92271 1.07775L8.00021 7.15525L14.0777 1.07775C14.4035 0.751916 14.9302 0.751916 15.256 1.07775C15.4185 1.24025 15.5002 1.45358 15.5002 1.66692Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectArrow);
export default __webpack_public_path__ + "static/media/selectArrow.452e1de8.svg";
export { ForwardRef as ReactComponent };